/**
 * GroupDropdownSearch
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString, deleteQueryString } from 'services/router/actions';

// Selectors
import { selectEquipmentSetOptionsBySprayEventType } from 'services/equipmentSets/selectors';

// Workspaces
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

interface Props {
    clearable?: boolean;
    singleFilter?: boolean;
}

const EquipmentSetDropdown = ({
    clearable,
    singleFilter
}: Props): React.ReactElement => {
    const dispatch = useDispatch();

    const sprayEquipmentSetId: number = useSelector(
        makeSelectQueryStringNumberValue('sprayEquipmentSetId')
    );
    const equipmentSets = useSelector(
        selectEquipmentSetOptionsBySprayEventType
    );

    const handleChange = (event: any, data: any) => {
        if (singleFilter) dispatch(deleteQueryString());

        dispatch(updateQueryString({ sprayEquipmentSetId: data.value }));
    };

    return (
        <Dropdown
            placeholder="All Equipment Sets"
            search
            selection
            value={sprayEquipmentSetId}
            clearable={clearable}
            selectOnBlur={false}
            options={equipmentSets}
            onChange={handleChange}
            lazyLoad
            closeOnChange
            fluid
        />
    );
};

EquipmentSetDropdown.defaultProps = {
    clearable: true,
    singleFilter: false
};

export default EquipmentSetDropdown;
